import {LinkingOptions} from '@react-navigation/native';
import {Routes, Screens} from '.';
import {Platform} from 'react-native';
import {deepLinkScheme} from '../constants';

export const linkingDesktop: LinkingOptions = {
  enabled: true,
  prefixes: [`${deepLinkScheme}/`, ''],
  config: {
    screens: {
      [Screens.CardServices]: {
        path: Routes.cardService,
      },
      [Screens.TransportService]: {path: Routes.transportService},
      [Screens.BankingService]: Routes.bankingService,
      [Screens.PrivilegesService]: Routes.privilegesService,
      [Screens.PrivilegesServiceDetails]: Routes.privilegesServiceDetails,
      [Screens.LoyaltyProgram]: Routes.loyaltyProgram,
      [Screens.LoyaltyProgramAcceptor]: Routes.loyaltyProgramAcceptor,

      [Screens.SupportService]: {
        path: Routes.supportService,
      },

      [Screens.SmsEmailSubscriptionControlScreen]: Routes.smsEmailSubscriptionControlPath,

      [Screens.Polls]: Routes.polls,
      [Screens.PollsTypeVote]: Routes.pollsTypeVote,
      [Screens.PollsTypeSurvey]: Routes.pollsTypeSurvey,
      [Screens.PollsTypeVoteForm]: Routes.pollsTypeVoteForm,
      [Screens.PollsTypeSurveyForm]: Routes.pollsTypeSurveyForm,

      [Screens.SupportServiceTopics]: Routes.supportServiceTopicsDesktop,
      [Screens.Notifications]: Routes.desktopNotifications,

      [Screens.SocialSupportMeasures]: {
        path: Routes.socialSupportMeasures,
      },
      [Screens.StateAssignments]: Routes.stateAssignments,
      [Screens.StatePrograms]: Routes.statePrograms,
      [Screens.ExpenseLiabilities]: Routes.expenseLiabilities,

      [Screens.Main]: Routes.main,
      [Screens.News]: Routes.news,
      [Screens.NewsArticle]: Routes.newsArticle,
      [Screens.VisuallyImpairedSettings]: Routes.visuallyImpairedSettings,
      [Screens.WebView]: Routes.webView,

      [Screens.Profile]: Routes.profile,
      [Screens.ProfileApplications]: Routes.profileApplications,
      [Screens.DesktopProfileMe]: Routes.profileMe,
      [Screens.DesktopProfileLinkedAccounts]: Routes.profileLinkedAccounts,
      [Screens.DesktopProfileSettings]: Routes.profileSettings,
      [Screens.ProfileConfirmation]: Platform.OS === 'web' ? Routes.confirmation : Routes.profileConfirmation,

      [Screens.VolunteersService]: Routes.volunteersService,
      [Screens.VolunteersServiceExchangeHistory]: Routes.volunteersServiceExchangeHistory,

      [Screens.RewardShop]: Routes.rewardShop,
      [Screens.ProductItem]: Routes.productItem,
      [Screens.Cashback]: Routes.cashBack,
      [Screens.ECertificates]: Routes.eCertificates,
      [Screens.CertificateItem]: Routes.certificateItem,
      // [Screens.Profile]: {
      //   initialRouteName: Screens.ProfileMenu,
      //   screens: {
      //     [Screens.ProfileMenu]: Routes.profileMenu,
      //     [Screens.ProfileBaseInfo]: Routes.profileBaseInfo,
      //     [Screens.ProfileUserDocuments]: Routes.profileUserDocuments,
      //     [Screens.ProfileUserContacts]: Routes.profileUserContacts,
      //     [Screens.DesktopProfileMe]: Routes.profileMe,
      //     [Screens.ProfileApplications]: Routes.profileApplications,
      //     [Screens.DesktopProfileSettings]: {
      //       initialRouteName: Screens.DesktopProfileSettings,
      //       screens: {
      //         [Screens.DesktopProfileSettings]: Routes.profileSettings,
      //         [Screens.ProfileNotificationSettings]: {
      //           path: Routes.profileNotificationSettings,
      //         },
      //       },
      //     },
      //   },
      // },
    },
  },
};

export const linkingMobile: LinkingOptions = {
  enabled: true,
  prefixes: [`${deepLinkScheme}/`, 'http://localhost:3000'],
  config: {
    screens: {
      [Screens.MainTabs]: {
        initialRouteName: Screens.Main,
        screens: {
          [Screens.Main]: {
            initialRouteName: Screens.Main,
            screens: {
              [Screens.Main]: Routes.mainMobile,
              [Screens.MainNotificationsItem]: Routes.mainNotificationsItem,
              [Screens.NewsArticle]: Routes.mainNewsArticle,
              [Screens.ChangeCityMobile]: Routes.changeCityMobile,
            },
          },
          ...(Platform.OS !== 'web'
            ? {
                [Screens.QrCodeCard]: {
                  initialRouteName: Screens.QrCodeCard,
                  screens: {
                    [Screens.QrCodeCard]: Routes.qrCodeCard,
                  },
                },
              }
            : {}),
          [Screens.CardServicesMenu]: {
            initialRouteName: Screens.CardServices,
            screens: {
              [Screens.CardServices]: {
                path: Routes.cardService,
              },
              [Screens.TransportService]: {path: Routes.transportService},
              [Screens.BankingService]: Routes.bankingService,
              [Screens.PrivilegesService]: Routes.privilegesService,
              [Screens.PrivilegesServiceDetails]: Routes.privilegesServiceDetails,
              [Screens.LoyaltyProgram]: Routes.loyaltyProgram,
              [Screens.LoyaltyProgramAcceptor]: Routes.loyaltyProgramAcceptor,
              [Screens.AcceptorsFilter]: Routes.acceptorsFilter,
              [Screens.VolunteersService]: Routes.volunteersService,
              [Screens.VolunteersServiceEvents]: Routes.volunteersServiceEvents,
              [Screens.VolunteersServiceExchangeHistory]: Routes.volunteersServiceExchangeHistory,
              [Screens.RewardShop]: Routes.rewardShop,
              [Screens.RewardShopFilters]: Routes.rewardShopFilters,
              [Screens.ProductItem]: Routes.productItem,
              [Screens.Cashback]: Routes.cashBack,
              [Screens.ECertificates]: Routes.eCertificates,
              [Screens.CertificateItem]: Routes.certificateItem,
            },
          },
          [Screens.Profile]: {
            initialRouteName: Screens.ProfileMenu,
            screens: {
              [Screens.ProfileMenu]: Routes.profileMenu,
              [Screens.ProfileBaseInfo]: Routes.profileBaseInfo,
              [Screens.ProfileUserDocuments]: Routes.profileUserDocuments,
              [Screens.ProfileUserContacts]: Routes.profileUserContacts,
              [Screens.ProfileConfirmation]: Platform.OS === 'web' ? Routes.confirmation : Routes.profileConfirmation,
              [Screens.ProfileUserPhoneConfirmation]: Routes.profileUserPhoneConfirmation,
              [Screens.ProfileUserEmailConfirmation]: Routes.profileUserEmailConfirmation,
              [Screens.ProfileNotificationSettings]: {
                path: Routes.profileNotificationSettings,
              },
              [Screens.ProfileChangePassword]: Routes.profileChangePassword,
              [Screens.DesktopProfileMe]: Routes.profileMe,
              [Screens.DesktopProfileLinkedAccounts]: Routes.profileLinkedAccountsDesktop,
              [Screens.ProfileApplications]: Routes.profileApplications,
              [Screens.ProfileApplicationsFilter]: Routes.profileApplicationsFilter,
              [Screens.ProfileApplicationsItem]: Routes.profileApplicationsItem,
              [Screens.DesktopProfileSettings]: Routes.profileSettings,
              [Screens.ProfileSafety]: Routes.profileSafety,
              [Screens.ProfileLinkedAccounts]: Routes.profileLinkedAccounts,
            },
          },
          [Screens.SocialSupportMeasuresMenu]: {
            initialRouteName: Screens.SocialSupportMeasures,
            screens: {
              [Screens.SocialSupportMeasures]: {
                path: Routes.socialSupportMeasures,
              },
              [Screens.StateAssignments]: Routes.stateAssignments,
              [Screens.StatePrograms]: Routes.statePrograms,
              [Screens.ExpenseLiabilities]: Routes.expenseLiabilities,
            },
          },
          [Screens.SupportServiceTab]: {
            initialRouteName: Routes.supportService,
            screens: {
              [Screens.SupportService]: {
                path: Routes.supportService,
              },
              [Screens.SupportServiceCreateTopic]: {
                path: Routes.supportServiceCreateTopic,
                exact: true,
              },
              [Screens.SupportServiceTopic]: {
                path: Routes.supportServiceTopic,
              },
              [Screens.SupportServiceTopics]: {
                path: Routes.supportServiceTopics,
              },
            },
          },
          [Screens.NotificationsMenu]: {
            initialRouteName: Screens.Notifications,
            screens: {
              [Screens.NotificationsItem]: {path: Routes.notificationsItem},
              [Screens.Notifications]: {path: Routes.mobileNotifications},
            },
          },
          [Screens.PollsMenu]: {
            initialRouteName: Screens.Polls,
            screens: {
              [Screens.Polls]: Routes.polls,
              [Screens.PollsTypeVote]: Routes.pollsTypeVote,
              [Screens.PollsTypeSurvey]: Routes.pollsTypeSurvey,
              [Screens.PollsTypeVoteForm]: Routes.pollsTypeVoteForm,
              [Screens.PollsTypeSurveyForm]: Routes.pollsTypeSurveyForm,
            },
          },
          [Screens.VisuallyImpairedSettings]: Routes.visuallyImpairedSettings,
          [Screens.News]: {
            initialRouteName: Screens.News,
            screens: {
              [Screens.News]: Routes.news,
              [Screens.NewsArticle]: Routes.newsArticle,
            },
          },
          [Screens.SmsEmailSubscriptionControlScreen]: Routes.smsEmailSubscriptionControlPath,
        },
      },
    },
  },
};

export const linkingLogin: LinkingOptions = {
  enabled: true,
  prefixes: [`${deepLinkScheme}/`, ''],
  config: {
    screens: {
      [Screens.Login]: Routes.login,
      [Screens.SmsEmailSubscriptionControlScreen]: Routes.smsEmailSubscriptionControlPath,
      [Screens.LoginConfirmation]: Platform.OS === 'web' ? Routes.confirmation : Routes.loginConfirmation,
      [Screens.VisuallyImpairedSettings]: Routes.visuallyImpairedSettings,
      [Screens.WebView]: Routes.webView,
    },
  },
};
